import React, { useMemo } from 'react';
import { AuthProvider, useAuth } from './providers/AuthProvider';
import { DraftProvider, useDraft } from './providers/DraftProvider';

export { useAuth, useDraft };

// Compatibility facade for consumers needing both independently memoized domains.
export function useApp() {
  const auth = useAuth();
  const draft = useDraft();
  return useMemo(() => ({ ...auth, ...draft }), [auth, draft]);
}

export const AppProvider = ({ children }) => (
  <DraftProvider><AuthProvider>{children}</AuthProvider></DraftProvider>
);